export const UPDATE_SERVER_SETTINGS_FAILURE = 'UPDATE_SERVER_SETTINGS_FAILURE';

export const updateServerSettingsFailure = (payload: Error) => ({
    type: UPDATE_SERVER_SETTINGS_FAILURE,
    payload,
});
